import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components";
import { useAppProperties } from "@/hooks";
import { useTranslate, useUser } from "@/providers/context";
import { cn } from "@/utils";
import { CloseMD } from "@/icons";

const BUTTON_STYLE = "w-full text-[16px] capitalize";

const Footer = ({ children }: { children: ReactNode }) => (
  <div className="bg-surface-primary border-border fixed bottom-0 left-0 right-0 z-30 flex items-center justify-center gap-4 border-t px-5 py-4 sm:hidden">
    {children}
  </div>
);

export const MobileFooter = () => {
  const { translate } = useTranslate();
  const navigate = useNavigate();
  const { uid } = useUser();
  const { data: properties } = useAppProperties();

  const [isDismissed, setIsDismissed] = useState(false);

  const deepLinkDomain = properties?.DeepLinkingDefaultLinkDomain;

  if (uid) {
    if (!deepLinkDomain || isDismissed) {
      return null;
    }

    return (
      <Footer>
        <div className="text-item-primary flex w-full min-w-[250px] max-w-[375px] flex-col">
          <div className="p2-bold mb-2">
            {translate("Want The Best Experience?")}
          </div>
          <div className="p2-medium mb-4">
            {translate(
              "Get the most out of your experience by downloading our user-friendly app.",
            )}
          </div>
          <Button
            size="l"
            className={BUTTON_STYLE}
            onClick={() =>
              window.open(`https://${deepLinkDomain}`, "noopener noreferrer")
            }
          >
            {translate("Download Our App")}
          </Button>
        </div>
        <div
          onClick={() => setIsDismissed(true)}
          className="text-item-primary absolute right-5 top-4 z-20 cursor-pointer"
        >
          <CloseMD className="h-6 w-6 sm:h-7 sm:w-7" />
        </div>
      </Footer>
    );
  }

  return (
    <Footer>
      <Button
        size="l"
        className={cn("max-w-[250px]", BUTTON_STYLE)}
        onClick={() => navigate("/sign-up")}
      >
        {translate("Sign up")}
      </Button>
      <Button
        size="l"
        variant="secondary"
        className={cn("max-w-[250px]", BUTTON_STYLE)}
        onClick={() => navigate("/sign-in")}
      >
        {translate("Sign in")}
      </Button>
    </Footer>
  );
};
